// extracted by mini-css-extract-plugin
export default {"strip":"RegisterCapsuleStepsRow_strip__3mkYI","disabledStep":"RegisterCapsuleStepsRow_disabledStep__3B6H6"};